const Top = () => {
    return (
        <div className="Top">
            <h1 className="latest">Latest News</h1>
            <h4 className="headText">Stay informed with trusted headlines, breaking stories, and global updates <br/> - delivering truth, speed, and clarity every moment.</h4>
        </div>
    );
}

export default Top;